import { ClientProvider } from "@nju/data-access-sales-client";
import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { PlaceOrderSuccessPage } from "@nju/feature-sales-order";
import { LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function PlaceOrderSuccess() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <ClientSideOnly>
        <ClientProvider>
          <PlaceOrderSuccessPage />
        </ClientProvider>
      </ClientSideOnly>
      <Footer />
    </LayoutWrapper>
  );
}
